import React, { useEffect, useState, useReducer } from 'react';
import { useCSS } from '../../lib/hooks.js';
import { FormattedMessage, injectIntl } from 'react-intl';
import { formatNumber, getRemotedbUrl, i18nIntl, isNotEmpty, UCFirst } from '../../lib/ep.js';
import { useFilterDataQuery, usePaginator, operators } from '../FilterContent';

import { SecondaryButton, SquaredButton } from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import ButtonCollection from '../builder/ButtonCollection.js';
import FloatingLayer from '../builder/FloatingLayer';
import NavigationTabs from '../builder/NavigationTabs';
import SaveButton from '../builder/SaveButton';
import SearchField from '../builder/SearchField';
import Spinner from '../builder/Spinner';
import TextArea from '../builder/TextArea';
import Tooltip from '../builder/Tooltip.js';

import { GalleryTags, OnlyGallery } from '../front/SingleGallery';
import SingleGallery from '../front/SingleGallery';

import ExportModal from './ExportModal';

import DeleteUserConfirm, { delMedia } from '../media/DeleteUserConfirm.js';
import VoteLogs from '../media/VoteLogs.js';
import Module from '../ui_items/Module.js';
import CandidateManager from '../users/CandidateManager.js';
import Paginator from '../utils/Paginator.js';
import FieldLabel from '../builder/FieldLabel.js';
import { stage_categories as stage_categories } from '../../data/bootstrap_stages.js';
import InputWithButton from '../builder/InputWithButton.js';
import SectionTitle from '../builder/SectionTitle.js';
import Model from '../builder/Model.js';
import { AlertMessage, SuccessMessage } from '../builder/Message.js';
import Select from '../builder/Select.js';

const ESCAPE_KEY = 27;
const ARROW_L = 37;
const ARROW_R = 39;

export const InnerComment = ({ participation, ...props }) => {
	const [ comment, setComment ] = useState((participation.extra && participation.extra.comment) ? participation.extra.comment : "");

	const saveComment = (e, cb) => {

		$.post(`/stages/inner_comment/${participation.promotion_id}/${participation.stage}`, { id:participation.id, comment }, (response) => {
			props.dispatch({
				type:'APPLYBULK_PARTICIPANT',
				bulk:(u) => {
					if(u.Participation.extra == undefined || u.Participation.extra == '') {
						u.Participation.extra = {};
					}
					if(comment == '') {
						delete u.Participation.extra.comment;
					} else {
						u.Participation.extra.comment = comment;
					}

					return u;
				},
				ids:[participation.id],
			});

			if(cb != undefined) cb();
			if(props.onSave != undefined)props.onSave(comment);
			props.backButton();
		});
	};

	return (
		<FloatingLayer backButton={props.backButton}>
			<div>
				<div class="gui_flexbox_auto">
					<div class="gui_not_in_end_big">
						<FieldLabel
							autotranslate={false}
							with_colon={false}
							force_display={true}
							empty_label={true}
						/>

						<ul class="gui_multimedia_gallery only_gallery">
							<OnlyGallery
								user={{ Participation:participation }}
							/>
						</ul>
					</div>

					<div style={{ flexGrow:'1' }}>
						<TextArea
							change={(k, v) => setComment(v)}
							value={comment}
							name="inner_comment"
							label_props={{
								tooltip:<Tooltip position='bottom'>Only the administrators can see it</Tooltip>
							}}
							_class={{ v_size:'big', first:true }}
						>Private comment</TextArea>
					</div>
				</div>

				<ButtonCollection in_floating={true}>
					<SaveButton
						onClick={saveComment}
					>Save</SaveButton>
				</ButtonCollection>
			</div>
		</FloatingLayer>
	)
};

const Wrapper = ({ stage, state, dispatch, ...props }) => {

	const stage_media = props?.stage_mirror?.Stage ?? stage;
	const stage_media_labels = (props.promotion?.available_media_tags ?? []).filter((t) => (stage_media?.media_tags ?? []).includes(t.id)).map(({ id, title }) => ({ k: id, v: title }));
	if(stage_media_labels.length > 0)stage_media_labels.unshift({ k:'', v:"All"});

	return (
		<section class="gui_users_registered full_height_flexed">
			<nav class="sticky_navigation">
				<NavigationTabs
					sections={props?.sections ?? []}
					_class={{ other:'gui_pos_rel_important' }}
				>
					<ButtonCollection>

						{(stage_media_labels.length > 0) && (
							<Select 
								name="period"
								change={(k, value) => props.searchByTag(value)}
								value={props.tag}
								values={stage_media_labels}
								_field_class="in_top"
								_class={{ first:true, size:70 }}
							>Tags</Select>
						)}

						<SearchField
							_class={{ first:true }}
							_field_class="in_top"
							name="search"
							value={props.search}
							change={props.searchEntries}
						/>
					</ButtonCollection>
				</NavigationTabs>
			</nav>

			<Module>
				{props.children}

				<Paginator
					{...props.pagination}
					goToPage={props.goToPage}
					min_pages_to_display={2}
					intl={props.intl}
				/>
			</Module>

			{(props.display_xxss != false) && (
				<AddUrlXXSS 
					intl={props.intl}
					promotion={props.promotion}
					stage={stage}
					network={props.display_xxss}
					close={()=>props.setDisplayXXSS(false)}
					/>
			)}
		</section>
	)
};

const AddUrlXXSS = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const network = props?.network ?? 'instagram';
	const network_name = UCFirst(network);

	const [ url, setUrl ] = useState('');
	const [ post, setPost ] = useState(false);
	const [ success, setSuccess ] = useState(false);
	const [ error, setError ] = useState(false);

	useEffect(() => {
		if(isNotEmpty(post, 'title', [''])) {
			setPost({
				...post,
				caption:post.title,
			});
		}
	}, [ post.title ]);

	const searchPost = (cb) => {
		$.post(getRemotedbUrl(`/users/getParamsSocial/${props.promotion.id}/${props.stage.id}`), {
			url,
			type:network,
		}, (result) => {
			if(result.status) {
				setPost(result.post);
			} else {
				setError(result.message);
			}

			if(cb != undefined) cb();
		}, 'JSON');
	};

	const addPost = (cb) => {
		$.post(getRemotedbUrl(`/users/add_post_network/${props.promotion.id}/${props.stage.id}`), {
			...post,
			url,
			xxss:network,
		}, (result) => {
			if(cb != undefined) cb();

			if(result.status) {
				setSuccess(true);
				return;
			}

			switch(result.reason) {
				case 'promotion_not_activated':
					setError(i18n("Promotion not activated."));
					break;

				default:
					setError(`${i18n("Unexpected error")}: ${result.reason}`);
					break;
			}
		}, 'JSON');
	};

	const changePost = (k, v) => {
		setPost({ ...post, [k]:v });
	};

	let ensure_domain = 'instagram.com';
	let placeholder_url = 'https://www.instagram.com/p/qMgQehgepQ/';
	let expreg_path = null;
	if(props.network == 'tiktok') {
		ensure_domain = 'tiktok.com'
		placeholder_url = 'https://www.tiktok.com/@easypromos/video/6885272465707109634';
		expreg_path = '(\\:\\d+)?(\\/[-a-z\\d%_.~+@]*)*';//Acceptem @
	}

	const post_selected = post ?? false;

	if(!post_selected) {
		return (
			<FloatingLayer
				backButton={() => props.close(false)}
				_class={{ size:'small' }}
			>
				<div class="without_actions">
					<SectionTitle
						autotranslate={false}
					>{props.intl.formatMessage({ id:"Add {network} post" }, { network:network_name })}</SectionTitle>

					<InputWithButton
						button_type='save'
						submitIcon='knk-search'
						name="url"
						force_model_errors={error}
						submitColor={(error) ? 'red' : null}
						value={url}
						_class={{ first:true }}
						input_type='url'
						enable_key_events={false}
						ensure_domain={ensure_domain}
						expreg_path={expreg_path}
						placeholder={placeholder_url}
						onSubmit={(e, cb) => searchPost(cb)}
						onChange={(k, v) => {
							setUrl(v);
							setError(false);
						}}
						autotranslate={false}
					>{props.intl.formatMessage({ id:"Insert the {network} Post URL" }, { network:network_name })}</InputWithButton>
				</div>
			</FloatingLayer>
		)
	}

	if(success) {
		return (
			<FloatingLayer
				backButton={() => props.close(false)}
				_class={{ size:'small' }}
			>
				<div class="without_actions">
					<SectionTitle
						autotranslate={false}
					>{props.intl.formatMessage({ id:"Add {network} post" }, { network:network_name })}</SectionTitle>

					<SuccessMessage
						title="Post imported successfully"
						_class={{ other:'in_bottom in_top' }}
					>	
						<p>{i18n("We created a new entry in your contest.")}</p>
						<p>
							<FormattedMessage
								id="{link} to display the new entry."
								values={{
									link:<ActionLink
										onClick={() => window.location.reload()}
									>Reload your browser</ActionLink>,
									network:network_name
								}}
							/>
						</p>
					</SuccessMessage>
				</div>
			</FloatingLayer>
		)
	}

	return (
		<FloatingLayer
			backButton={() => props.close(false)}
			_class={{ size:'small' }}
		>
			<div>
				<SectionTitle
					autotranslate={false}
				>{props.intl.formatMessage({ id:"Add {network} post" }, { network:network_name })}</SectionTitle>

				<div
					style={{
						display:'flex',
						gap:'1em'
					}}
				>
					<div style={{ flex:'0 0 150px' }}>
						<img
							src={post.thumbnail_url}
							width="100%"
							alt=""
							style={{
								outline:'1px solid rgba(var(--main-text-color), 0.2)',
								outlineOffset:'0',
							}}
						/>
					</div>

					<div style={{ flexGrow:'1' }}>
						<Model model={post} change={changePost}>
							<TextArea
								name="caption"
								_class={{ first:true }}
							>Description</TextArea>
						</Model>

						<div class="gui_not_in_top_small" style={{ display:'flex', flexDirection:'column', gap:'0.5em' }}>
							<div>
								{i18n("User")}:<br />
								<strong>@{post.author_name}</strong>
							</div>

							<div>
								{i18n("Direct link")}:<br />
								<strong>
									<ActionLink
										_href={url}
										_target='_blank'
										style={{
											wordBreak:'break-all'
										}}
									>{url}</ActionLink>
								</strong>
							</div>
						</div>
					</div>
				</div>

				{(error !== false) && (
					<AlertMessage _class={{ other:'in_bottom' }}>
						<p>{error}</p>
					</AlertMessage>
				)}

				<ButtonCollection in_floating={true}>
					<SaveButton
						onClick={(e, cb) => addPost(cb)}
					>Add post</SaveButton>

					<SecondaryButton
						onClick={() => props.close()}
					>Cancel</SecondaryButton>
				</ButtonCollection>
			</div>
		</FloatingLayer>
	)
}

const MultiMediaTool = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	useCSS('comp/multigallery.css');
	useCSS('comp/owner_multigallery.css');
	const stage = props?.stage ?? false;
	const promotion = props?.promotion ?? false;
	const integrations = props?.integrations ?? [];
	const is_votes = props?.is_votes ?? false;
	const items_per_page = 30;

	const [ deleteConfirm, setDeleteConfirm ] = useState(false);
	const [ loading, setLoading ] = useState(false);
	const [ search, setSearch ] = useState("");
	const [ tag, setTag ] = useState(null);
	const [ display_inner_comment_layer, setDisplayInnerCommentLayer ] = useState(false);
	const [ display_xxss, setDisplayXXSS ] = useState(false);
	const [ edit_entry, setEditEntry ] = useState(false);

	const handleKeyDown = (e) => {
		switch(e.keyCode) {
			case ESCAPE_KEY:
				closeEntryAsLayer();
				break;

			case ARROW_L:
				goPrevMedia();
				break;

			case ARROW_R:
				goNextMedia();
				break;
		}
	};

	useEffect(() => {
		document.addEventListener('keydown', handleKeyDown);

		return () => {
			document.removeEventListener('keydown', handleKeyDown);
		}
	}, []);

	const getUsers = (start = false, limit = 100) => {
		if(limit == 100) setLoading(true);

		let url;
		switch(parseInt(stage.type)) {
			case stage_categories.ID_MEDIA_CATEGORY.id:
			case stage_categories.ID_PHOTO_FUN.id:
				url = `/users/fetch_gallery/${stage.id}`;
				break;
				
			case stage_categories.ID_VOTING_CATEGORY.id:
				url = `/stages/getvotingcandidates/${stage.promotion_id}/${stage.id}`;
				break;
		}

		return $.getJSON(getRemotedbUrl(url), { start, limit }, (res) => {
			setLoading(false);
		});
	}

	const [ galleryState, dispatchGallery ] = useReducer((state, action) => {
		switch(action.type) {
			case 'OPEN_ENTRY':
				return { ...state, current_participation:action.participation, current_media:action.media_index };

			case 'EDIT_PARTICIPATION':
				return { ...state, edit_participation:action.participation };

			case 'CLOSE_EDIT_PARTICIPATION':
				return { ...state, edit_participation:{} };

			case 'CLOSE_ENTRY':
				return { ...state, current_participation:false, current_media:0 };

			case 'NEXT_MEDIA':
				if(state.current_participation == false) return state;
				let next_index = (state.current_media + 1) % state.current_participation.quiz_entry.media.length;
				return { ...state, current_media:next_index };

			case 'PREV_MEDIA':
				if(state.current_participation == false) return state;
				let prev_index = (state.current_media - 1);
				if(prev_index < 0) prev_index = state.current_participation.quiz_entry.media.length-1;
				return { ...state, current_media:prev_index };

			case 'SHOW_VOTE_LOGS':
				return { ...state, show_vote_logs:(state.show_vote_logs.id == undefined || state.show_vote_logs.id != action.participation.id) ? action.participation : false };

			case 'SHOW_FRAUD_VOTE_LOGS':
				const _show_fraud_vote_logs = (state.show_fraud_vote_logs.id == undefined || state.show_fraud_vote_logs.id != action.participation.id) ? action.participation : false;
				return { ...state, show_fraud_vote_logs:_show_fraud_vote_logs, fraud_points:action?.fraud_points ?? null };

			case 'SHOW_EXPORT':
				let action_export = action.id;
				let state_export = state.show_export;
				return { ...state, show_export:(state_export.id == action_export.id && state_export.export == action_export.export) ? {} : action_export}

			default:
				return state;
		}
	}, {
		current_media:0,
		current_participation:false,
		show_vote_logs:false,
		show_fraud_vote_logs:false,
		fraud_points:null,
		edit_participation:{},
		show_export:{},
	});

	const [ state, dispatch, fetchAll,refetch ] = useFilterDataQuery(`media_${stage.type}`, getUsers, {
		indexer:(indexed, element) => {},
		limit:items_per_page,
		pagination:500,
		fetch_all_disabled:false,
		items_per_page:items_per_page,
	});

	if(is_votes && state.sort == undefined && state.filtered != undefined) {
		(state.filtered).sort((a, b) => {
			return b.StageVote.points - a.StageVote.points;
		});
	}

	const [ data, pagination, goToPage ] = usePaginator(state.filtered, items_per_page);

	if(stage === false) return null;

	const goPrevMedia = () => {
		dispatchGallery({ type:'PREV_MEDIA' });
	};

	const goNextMedia = () => {
		dispatchGallery({ type:'NEXT_MEDIA' });
	};

	const openEntryAsLayer = (participation, media_index) => {
		dispatchGallery({
			type:'OPEN_ENTRY',
			participation,
			media_index,
		});
	};

	const editParticipation = (participation) => {
		dispatchGallery({type:'EDIT_PARTICIPATION', participation });
	};

	const toggleVoteLogs = (participation) => {
		dispatchGallery({ type:'SHOW_VOTE_LOGS', participation });
	};

	const toggleFraudVoteLogs = (participation, fraud_points = null, recalculate = false) => {
		dispatchGallery({ type:'SHOW_FRAUD_VOTE_LOGS', participation, fraud_points });
		if(recalculate) {
			refetch();
		}
	};

	const toggleExport = (id) => {
		dispatchGallery({ type:'SHOW_EXPORT', id });
	};

	const closeEntryAsLayer = () => {
		dispatchGallery({ type:'CLOSE_ENTRY' });
	};

	const bulkAction = (type, user_id, data) => {
		let bulk = null;
		let bulk_on_response = null;
		const info = { ids:JSON.stringify([user_id]) };
		switch(type) {
			case 'star':
				bulk = (u) => {
					u.Participation.marked = 1;
					u.marked = 1;
					return u;
				}
				break;

			case 'unstar':
				bulk = (u) => {
					u.Participation.marked = 0;
					u.marked = 0;
					return u;
				}
				break;

			case 'reject':
				bulk = (u) => {
					u.Participation.public_entry = 4;
					return u;
				}
				break;

			case 'accept':
				bulk = (u) => {
					u.Participation.public_entry = 1;
					return u;
				}
				break;
			
			case 'update_media':
				info.quiz_entry = data.quiz_entry;

				bulk = (u) => {
					u.Participation.processing_media = true;
					return u;
				}

				bulk_on_response = true
				break;
		}

		if(bulk) {
			dispatch({
				type:'APPLYBULK_PARTICIPANT',
				bulk,
				ids:[user_id],
			});
		}
		
		$.post(`/users/apply_bulk/${type}/${props.promotion.id}`, info, (result) => {
			if(bulk_on_response) {
				if(result.status){
					bulk = (u) => {
						u.Participation.quiz_entry = result.participation.quiz_entry;
						u.Participation.public_entry = result.participation.public_entry;
						u.Participation.processing_media = false;
						return u;
					}
					dispatch({
						type:'APPLYBULK_PARTICIPANT',
						bulk,
						ids:[user_id],
					});
				}
			}
		}, 'JSON');
	};

	const deleteMedia = (participation, confirm) => {
		if(confirm !== undefined && confirm == true) {
			delMedia(participation, confirm, false, () => {
				dispatch({ type:'REMOVE_ENTRY', uid:participation.id });
				setDeleteConfirm(false);
			});
			return;
		}
		delMedia(participation, confirm, false, (response) => { setDeleteConfirm({ ...response, participation }); });
	}

	const searchEntries = (k, value) => {
		const filter = {
			key:'search',
			name:i18n("Name"),
			tier1:['Participation.search_media_values'],
			tier2:{ ...operators.textOperators },
			tier3:'input',
			type:'string',
		};

		dispatch({
			type:'SETFILTER',
			filter:{
				key:'search',
				value,
				operator:'like_all',
				filter,
			},
			unique:true,
		});

		setSearch(value);
	};

	const searchByTag = (tag) => {
		const filter = {
			key:'search_tag',
			name:"Tags",
			type:'in_array',
			tier1:(user) => {
				return user.Participation.quiz_entry.tags;
			},
		};

		dispatch({
			type:'SETFILTER',
			filter:{
				key:'search_tag',
				value:tag,
				operator:'in_array',
				filter,
			},
			unique:true,
		});
		setTag(tag);
	};

	if(loading) {
		return (
			<div>
				<Module style={{minHeight:'300px'}}>
					<Spinner autotranslate={false}>{i18n("Loading the gallery")}...</Spinner>
				</Module>
			</div>
		)
	}

	const sections = [{ label:"Go back", icon:'knk-arrow-l-big', router:true, full_link:`/` }];
	if(is_votes) {
		if(props.back_to_stages_url)sections.push({label:"Galleries list", full_link:`${props.back_to_stages_url}`, router:true, icon:'knk-quiz'});
		sections.push({label:"Export all votes", onClick:() => toggleExport({ id:'media_votes', export:'all' }), icon:'knk-like'});
		sections.push({label:"Export results", onClick:() => toggleExport({ id:'media_results', export:'all' }), icon:'knk-download'});
	} else {
		sections.push({label:"Export entries", onClick:() => toggleExport({ id:'media_entries', export:'all' }), icon:'knk-export-users'});
		//sections.push({label:"Export files for bulk download", onClick:() => toggleExport({ id:'media_files', export:'all' }), icon:'knk-download'});
		sections.push({label:"Download Multimedia Content", onClick:() => toggleExport({ id:'zip_files', export:'all' }), icon:'knk-download'});

		const has_active_ig_integration = integrations.find((i) => (i.type == 3));
		if(has_active_ig_integration || props.promotion.promotion_type_id == 58) {
			sections.push({ autotranslate:false, label:props.intl.formatMessage({ id:"Add {network} post" }, { network:'Instagram' }), onClick:() => setDisplayXXSS('instagram'), icon:'ep-instagram' });
		}
		if(stage.media_tiktok || props.promotion.promotion_type_id == 58) {
			sections.push({ autotranslate:false, label:props.intl.formatMessage({ id:"Add {network} post" }, { network:'TikTok' }), onClick:() => setDisplayXXSS('tiktok'), icon:'ep-tiktok' });
		}
	}

	const show_export_modal = (Object.keys(galleryState.show_export).length > 0) ? true : false;
	const export_modal_info = (show_export_modal) ? galleryState.show_export.export : {};

	let props_export = {};
	if(Object.keys(export_modal_info).length > 0) {
		props_export.stage_id = stage.id;
		props_export.promotion = props.promotion;
		props_export.stages = props.stages
		props_export.agent_email = props.agent_email;
		props_export.type = galleryState.show_export.id;
		props_export.toggle = () => toggleExport(galleryState.show_export);
		if(export_modal_info.id)props_export.filtered = [{ Participation:export_modal_info }];

		let filename;
		switch(galleryState.show_export.id) {
			case 'media_votes':
				filename = 'all_votes_';
				if(export_modal_info.id) filename = 'participant_votes_';
				break;

			case 'media_results':
				filename = 'result_votes_';
				break;

			case 'media_entries':
				filename = 'multimedia_entries_';
				break;

			case 'media_files':
				filename = 'multimedia_urls_';
				break;

			case 'zip_files':
				props_export.title= `${i18n("Download Type")}: ZIP Files`;
				props_export.subtitle = i18n("One or more ZIP files with the multimedia content of the contest will be generated.");
				filename=`zip_files_${props.promotion.id}_${stage.id}`;
				break;
		}
		filename += `${promotion.id}_${stage.id}`;

		if(export_modal_info.id)filename += `_${export_modal_info.id}`;
		props_export.filename = filename;
	}

	const wrapper_props = {
		stage,
		stage_mirror: props.stages.find((s) => { return s.Stage.id == stage.voting_mirror }),
		state,
		dispatch,
		sections,
		searchEntries,
		search,
		searchByTag,
		tag,
		pagination,
		goToPage,
		intl:props.intl,
		display_xxss,
		promotion,
		setDisplayXXSS
	};

	const main_classes = ['multigallery_tool', 'simple_registered_entries_list', 'is_voting_gallery'];

	if(data.length == 0) {
		// No items yet
		return (
			<Wrapper {...wrapper_props}>
				<ul class={main_classes.join(" ")}>
					<li>{i18n("There are no results.")}</li>
				</ul>
			</Wrapper>
		)
	}

	if(!is_votes) {
		// Multimedia Tool
		return (
			<>
				{(edit_entry != false) && (
					<CandidateManager 
						promotion={promotion}
						stage={stage}
						user={edit_entry}
						allow_delete={(edit_entry.User.id != undefined) ? true : false}
						is_edit_builder={(edit_entry.User.id != undefined) ? true : false}
						close={() => setEditEntry(false)}
						onSave={(candidate) => {
							dispatch({
								type:'APPLYBULK_PARTICIPANT',
								bulk:(user) => {
									return { Participation:candidate.User };
								},
								ids:[edit_entry.User.id],
							});
							setEditEntry(false);
						}}
						onDelete={(candidate_id) => {
							dispatch({ type:'REMOVE_ENTRY',uid:candidate_id });
							setEditEntry(false);
						}}
					/>
				)}

				<Wrapper {...wrapper_props}>
					<ul class="gui_white_bg_total only_gallery gui_multimedia_gallery has_column_of_4 gui_main_text_color_on_bg">
						{data.map((_user, u) => {
							if(_user.Participation == undefined) return null;
							const user = _user.Participation;

							return (
								<SingleGallery
									key={user.id}
									item_id={`gallery_${user.id}`}
									promotion={promotion}
									stage={stage}
									user={{ Participation:user }}
									has_voting_sidebar={false}
									is_votable={false}
									is_builder={true}
									selected_entry={(galleryState.current_participation !== false && galleryState.current_participation.id == user.id) ? user.id : null}
									onEdit={() => setEditEntry({ User:user })}
									openDetailLayer={() => openEntryAsLayer(user, 0)}
									closeEntryAsLayer={closeEntryAsLayer}
									is_editable={true}
									intl={props.intl}
								/>
							)
						})}
					</ul>
				</Wrapper>

				{(show_export_modal) && (
					<ExportModal 
						{...props_export} 
						promotion_id={promotion.id}
					/>
				)}

				{(display_inner_comment_layer != false) && (
					<InnerComment
						participation={display_inner_comment_layer}
						dispatch={dispatch}
						backButton={() => setDisplayInnerCommentLayer(false)}
					/>
				)}

				{(deleteConfirm != false) && (
					<DeleteUserConfirm
						response={deleteConfirm}
						confirm={() => deleteMedia(deleteConfirm.participation, true)}
						backButton={() => setDeleteConfirm(false)}
					/>
				)}
			</>
		)
	}

	return (
		<>
			<Wrapper {...wrapper_props} >
				<ul class={main_classes.join(" ")}>
					<li class="list_header single_item">
						<div class="tabled_item">
							<span class="user_name gui_force_bold gui_pos_rel" style={{ height:'1em' }}>
								<span class="gui_cutTextOnOverflow">
									{i18n("Total")}: {state.total} | {i18n("Gallery")}: {stage.display_title}
								</span>
							</span>

							<span class="extra_col">{i18n("Submitted")}</span>

							<span class="is_score">{i18n("votes", 'ucfirst')}</span>

							{/* COMENTAT TEMPORALMENT FINS QUE ESTIGUI EL CENTRO DE SEGURIDAD */}
							<span class="is_score">{i18n("Fraudulent votes")}<Tooltip position='bottom'>A vote is flagged as fraudulent if it has been cast by a blocked user. A user can be blocked for these three reasons: (1) the administrator manually blocks them, (2) the administrator blocks all users using a specific email domain or ip address, (3) the system automatically blocks the user for being part of a pattern of fraudulent votes.</Tooltip></span>

							<span class="user_actions">{i18n("Actions")}</span>
						</div>
					</li>

					{data.map((_user, u) => {
						if(_user.Participation == undefined) return null;

						const participation = _user.Participation;
						const stage_vote = _user?.StageVote ?? {};
						const points = stage_vote?.points ?? 0;
						let composite_name =  `${participation.name}`;
						if(participation.first_name && participation.last_name) composite_name = `${participation.first_name} ${participation.last_name}`;

						const fraud_points = stage_vote?.blocked ?? 0;
						const fraud_percent = (points > 0) ? (100 * fraud_points / points) : 0;
						let fraud_color = 'green';
						if(fraud_percent >= 70) {
							// high fraud in participation:
							fraud_color = 'red';
						} else if(fraud_percent >= 40) {
							// mid-high fraud in participation:
							fraud_color = 'orange';
						} else if(fraud_percent >= 20) {
							// mid-low fraud in participation:
							fraud_color = 'yellow';
						}

						return (
							<li key={`user_${u}`} class="gui_ranking gui_multi_ranking in_audience">
								<div class="tabled_item">
									<div class="ranking_pos">{u + 1}</div>

									<div class="media_main">
										<ul class="gui_multimedia_gallery gui_main_text_color_on_bg">
											<SingleGallery
												is_in_ranking={true}
												media_index={0}
												promotion={promotion}
												selected_entry={(galleryState.current_participation !== false && galleryState.current_participation.id == participation.id) ? participation.id : null}
												stage={stage}
												user={{ ..._user, Participation:participation }}
												in_registered={true}
												closeEntryAsLayer={closeEntryAsLayer}
												openDetailLayer={() => openEntryAsLayer(participation, 0)}
											/>
										</ul>

										<div class="in_top">
											<h3>
												<strong class="gui_cutTextOnOverflow'">{participation.name}</strong>
											</h3>

											{(isNotEmpty(participation.extra, 'short_description')) && (
												<p class='short_description gui_not_in_top_tiny' dangerouslySetInnerHTML={{ __html:participation.extra.short_description }} />
											)}
											<GalleryTags
												user={{Participation:participation}}
												promotion={promotion}
												classes="gui_not_in_top_tiny"
											/>
										</div>
									</div>

									<span class="extra_col">
										{(participation.net_type == 12) && (
											<FormattedMessage
												id="By {name}"
												values={{ name:<strong style={{marginLeft:'0.2em'}}>{i18n("Admin")}</strong> }}
											/>
										)}

										{(participation.net_type != 12 && participation.name != composite_name) && (
											<FormattedMessage
												id="By {name}"
												values={{ name:<strong style={{marginLeft:'0.2em'}}><ActionLink
													onClick={() => props.open_info_layer(participation.login_id)}
													_class={{ other:'gui_cutTextOnOverflow' }}
													autotranslate={false}
												>{`${composite_name}`}</ActionLink></strong> }}
											/>
										)}

										<span class="gui_force_same_line">{i18n("on")} {EPDateFormat(participation.created, 'L, LT')} h</span>
									</span>

									<span class="is_score">
										<span>
											{points}

											{(points > 0) && (
												<span class="gui_not_in_start_small">[<ActionLink onClick={() => toggleVoteLogs(participation)}>View</ActionLink>]</span>
											)}
										</span>
									</span>

									{/* COMENTAT TEMPORALMENT FINS QUE ESTIGUI EL CENTRO DE SEGURIDAD */}
									<span class="is_score">
										<span class="status_actions fraud_status">
											<span class={`ep-circle ${fraud_color}Icon`} />

											<span>
												{fraud_points > 0 ? `${fraud_points} (${formatNumber(fraud_percent)}%)`: fraud_points}

												{(fraud_points > 0) && (
													<span class="gui_not_in_start_small">[<ActionLink onClick={() => toggleFraudVoteLogs(participation,fraud_points)}>View</ActionLink>]</span>
												)}
											</span>
										</span>
									</span>

									<ButtonCollection _class={{other:'user_actions gui_not_margined_v'}}>
										{(points > 0) && (
											<SquaredButton
												icon='knk-download'
												tooltip={<Tooltip position="top" with_icon={false}>Export the votes of this entry</Tooltip>}
												onClick={() => toggleExport({ id:'media_votes', export:participation })}
												aria-label="Export the votes of this entry"
											/>
										)}
									</ButtonCollection>
								</div>
							</li>
						)
					})}
				</ul>
			</Wrapper>

			{(show_export_modal) && (
				<ExportModal 
					{...props_export} 
					promotion_id={promotion.id}
				/>
			)}

			{(galleryState.show_vote_logs != false) && (
				<FloatingLayer
					_class={{size:'normal'}}
					backButton={() => toggleVoteLogs(galleryState.show_vote_logs)}
				>
					<VoteLogs
						stage={stage}
						promotion={promotion}
						participation={galleryState.show_vote_logs}
						open_info_layer={props.open_info_layer}
					/>
				</FloatingLayer>
			)}

			{(galleryState.show_fraud_vote_logs != false) && (
				<FloatingLayer
					_class={{size:'normal'}}
					backButton={() => toggleFraudVoteLogs(galleryState.show_fraud_vote_logs,null,true)}
				>
					<VoteLogs
						display_blocked={true}
						fraud_points={galleryState.fraud_points}
						stage={stage}
						promotion={promotion}
						participation={galleryState.show_fraud_vote_logs}
						open_info_layer={props.open_info_layer}
						close={() => toggleFraudVoteLogs(galleryState.show_fraud_vote_logs,null,true)}
					/>
				</FloatingLayer>
			)}
		</>
	);
}

export default injectIntl(MultiMediaTool);